import {useMemo} from 'react';
import type {BrandKitWithAssets} from '@Components/mystuff-brands/brand-kits.types';
import {createBrandKitWithAssetsObject} from '@Libraries/brands-library';
import {useBrandKitsFromStore} from '@Hooks/brands/useBrandKitsFromStore';
import {useBrandKitAssetSources} from '@Hooks/brands/useBrandKitAssetSources';

export const useBrandKitsWithAssets = (): BrandKitWithAssets[] => {
  const brandKits = useBrandKitsFromStore();
  const assetSources = useBrandKitAssetSources();

  return useMemo(() => {
    return brandKits.map((brandKit) => {
      return createBrandKitWithAssetsObject({brandKit, ...assetSources});
    });
  }, [brandKits, assetSources]);
};
